import { useMemo, useRef, useState } from "react";
import type { Recall } from "../shared/types";
import { HERO_POSTER_PATH, HERO_VIDEO_PATH } from "../shared/media";
import { recentRecallCaptions } from "./recallCaptions";

const CAPTION_CUES = [12.2, 15, 21.6, 24.6, 34.44, 36.56, 46, 52.12, 55.76, 60.8, 64.32, 68.04, 71.04, 75.2];

function captionAt(currentTime: number, captions: string[]): string {
  if (currentTime < CAPTION_CUES[0]) return "THIS WEEK IN RECALLED FOOD";
  let cueIndex = 0;
  for (let index = 1; index < CAPTION_CUES.length; index += 1) {
    if (currentTime < CAPTION_CUES[index]) break;
    cueIndex = index;
  }
  return captions[cueIndex % captions.length] ?? captions[0];
}

export function RecallVideo({ recalls }: { recalls: Recall[] }) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [muted, setMuted] = useState(true);
  const captions = useMemo(() => recentRecallCaptions(recalls), [recalls]);
  const caption = captionAt(currentTime, captions);

  const toggleSound = () => {
    const nextMuted = !muted;
    setMuted(nextMuted);
    if (videoRef.current) videoRef.current.muted = nextMuted;
  };

  return (
    <div className="recall-video">
      <video
        ref={videoRef}
        className="recall-video-player"
        autoPlay
        loop
        muted={muted}
        playsInline
        poster={HERO_POSTER_PATH}
        preload="metadata"
        onCanPlay={(event) => void event.currentTarget.play().catch(() => undefined)}
        onTimeUpdate={(event) => setCurrentTime(event.currentTarget.currentTime)}
      >
        <source src={HERO_VIDEO_PATH} type="video/mp4" />
      </video>
      <button
        className="recall-video-sound"
        type="button"
        aria-pressed={!muted}
        onClick={toggleSound}
      >
        {muted ? "SOUND OFF" : "SOUND ON"}
      </button>
      <div className="recall-video-caption" aria-label={`Always-on recall subtitle: ${caption}`}>
        {caption}
      </div>
    </div>
  );
}
